export const aboutInfo = {
  brandName: '番茄视频',
  tagline: '您的随身高清影院',
  intro: '番茄视频成立于2020年，是一家专注于提供高清影视内容在线观看服务的综合性视频平台。我们致力于为用户打造极致流畅的高清观影体验，让每一位影视爱好者都能随时随地享受优质内容。',
  mission: '以技术驱动观影体验，用内容温暖每一个夜晚',
  vision: '成为华人世界最受欢迎的高清影视平台',
  stats: [
    { value: '5000万+', label: '注册用户' },
    { value: '10万+', label: '影视资源' },
    { value: '99.9%', label: '服务可用率' },
    { value: '4.9', label: '用户评分' },
  ],
  milestones: [
    { year: '2020', event: '番茄视频正式上线，主打高清电影在线播放' },
    { year: '2021', event: '用户突破1000万，上线电视剧和综艺频道' },
    { year: '2022', event: '推出4K超清画质，覆盖动漫频道' },
    { year: '2023', event: '注册用户突破3000万，智能推荐系统上线' },
    { year: '2024', event: '获得行业年度最佳视频平台奖' },
    { year: '2025', event: '用户突破5000万，内容库超10万部影视资源' },
    { year: '2026', event: '全面升级AI智能画质增强技术，开启超高清时代' },
  ],
  testimonials: [
    {
      name: '张先生',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20in%20business%20attire%2C%20warm%20studio%20lighting%2C%20clean%20cream%20background%2C%20friendly%20expression%2C%20corporate%20headshot%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
      comment: '用了番茄视频两年多了，画质真的没话说。4K超清播放流畅不卡顿，资源更新也很快，新剧上线当天就能看，强烈推荐！',
      rating: 5,
    },
    {
      name: '李女士',
      avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20female%20portrait%20with%20warm%20smile%2C%20soft%20studio%20lighting%2C%20clean%20cream%20background%2C%20natural%20expression%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
      comment: '作为一名资深追剧党，番茄视频是我用过最好的视频平台。分类清晰，界面简洁，最重要的是没有烦人的广告弹窗。',
      rating: 5,
    },
    {
      name: '王同学',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20with%20glasses%2C%20warm%20casual%20atmosphere%2C%20clean%20cream%20background%2C%20friendly%20smile%2C%20natural%20headshot%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
      comment: '动漫资源超级全！追了多年的番在番茄视频上都有高清版，画质比之前在其他平台看的好太多了。国漫也越来越多了，好评！',
      rating: 5,
    },
  ],
  contact: {
    email: 'support@fanqie.video',
    phone: '400-888-6688',
    address: '北京市朝阳区望京科技园番茄视频大厦',
    workingHours: '周一至周日 9:00 - 21:00',
  },
};